import {combineReducers} from 'redux';
import homeThyro from "./homeThyro";

const rootReducers = combineReducers({
    homeThyro
});

// export default rootReducers;
export default rootReducers;
